// pngElevationTileTerrainProvider.js
// ver 1.1.1, 2016-09-13 西岡 芳晴 ( NISHIOKA Yoshiharu )
// PNG標高タイルを使うためのCesium用TerrainProvider
// Webメルカトル，正距円筒図法に対応，法線ベクトルに対応
import when from '../ThirdParty/when.js';
import defaultValue from'./defaultValue.js';
import defined from './defined.js';
import defineProperties from './defineProperties.js';
import Ellipsoid from './Ellipsoid.js';
import Event from './Event.js';
import GeographicTilingScheme from './GeographicTilingScheme.js';
import HeightmapTerrainData from './HeightmapTerrainData.js';
import TerrainProvider from './TerrainProvider.js';
import WebMercatorTilingScheme from './WebMercatorTilingScheme.js';
import CMath from './Math.js';
import QuantizedMeshTerrainData from './QuantizedMeshTerrainData.js';
import loadImage from './loadImage.js';
import getImagePixels from './getImagePixels.js';
import Credit from './Credit.js';
import BoundingSphere from './BoundingSphere.js';
import Cartesian3 from './Cartesian3.js';
import OrientedBoundingBox from './OrientedBoundingBox.js';

    function pngElevationTileTerrainProvider(description) {
//        description = defaultValue(options, {});
        description = defaultValue( description, defaultValue.EMPTY_OBJECT );

//	var defaultUrl = 'http://gsj-seamless.jp/labs/elev2/elev/{z}/{y}/{x}.png?size=257';
        var defaultUrl = 'https://gsj-seamless.jp/labs/elev2/php/elev.php?z={z}&y={y}&x={x}&size=257';
	// 以下作業用
        var defaultCredit = 'シームレス地質情報標高サービス実験公開';
    	var defaultHeightWidth = 64;	// 標高マップの幅
    	var defaultMaximumLevel = 14;	// 最大ズームレベル,
    	var defaultTileWidth = 257;	// タイル画像のサイズ

//      defaultValue,
//      defined,
//    	PngElevationTileTerrainProvider;

//	if ( typeof Cesium === 'undefined' ) {
										// Cesiumが利用できない環境では何も返さず終了
//		return;
//	}

//	defaultValue = Cesium.defaultValue,
//      defined = Cesium.defined,
//      PngElevationTileTerrainProvider = function( description ) {

    	var	credit;
    	var	tileWidth;	// タイルの画像幅

        this._url = defaultValue( description.url, defaultUrl );
        this._proxy = description.proxy;

	if ( typeof description.tilingScheme !== 'undefined' ){
		// tilingSchemeの指定があればそれを使用
		this._tilingScheme = description.tilingScheme;
	} else {
	        // デフォルトのtilingSchemeはWebメルカトルを使用
                // this._tilingScheme = new Cesium.WebMercatorTilingScheme( {
       		this._tilingScheme = new WebMercatorTilingScheme({
	        	numberOfLevelZeroTilesX: 2
	        	// Cesium 1.14現在，WebMeractorの標高では1は指定できない
	        });
	}
	this._heightmapWidth = defaultValue( description.heightMapWidth, defaultHeightWidth );
	this._maximumLevel = defaultValue( description.maximumLevel, defaultMaximumLevel );
	this._useVertexNormals = defaultValue( description.useVertexNormals, false );
        this._terrainDataStructure = {
            heightScale :  defaultValue( description.heightScale, 1 ),
            heightOffset : defaultValue( description.heightOffset, 0 ),
//            elementsPerHeight : 1,		//デフォルト値なので指定する必要無し
//            stride : 1,			//デフォルト値なので指定する必要無し
//            elementMultiplier : 256,		//デフォルト値なので指定する必要無し
        };
        this._levelZeroMaximumGeometricError = 
//        		Cesium.TerrainProvider.getEstimatedLevelZeroGeometricErrorForAHeightmap(
        	TerrainProvider.getEstimatedLevelZeroGeometricErrorForAHeightmap(
        		this._tilingScheme.ellipsoid, 
        		this._heightmapWidth,
        		this._tilingScheme.getNumberOfXTilesAtLevel( 0 )
        	);
//      this._errorEvent = new Cesium.Event();
        this._errorEvent = new Event();
        credit = defaultValue( description.credit, defaultCredit );
        if (typeof credit === 'string') {
//          credit = new Cesium.Credit( credit );
            credit = new Credit( credit );
        }
        this._credit = credit;
        
        tileWidth = defaultValue( description.tileWidth, defaultTileWidth );
        this._zoomAdjustment = Math.floor( 
        		Math.log( tileWidth / this._heightmapWidth / 2 ) * Math.LOG2E );
    };

//    Cesium.defineProperties( PngElevationTileTerrainProvider.prototype, {
    defineProperties( pngElevationTileTerrainProvider.prototype, {
        errorEvent : {
            get : function() {
                return this._errorEvent;
            }
        },
        credit : {
            get : function() {
                return this._credit;
            }
        },
        tilingScheme : {
            get : function() {
                return this._tilingScheme;
            }
        },
        ready : {
            get : function() {
                return true;
            }
        },
        hasWaterMask : {
            get : function() {
                return false;
            }
        },
        hasVertexNormals : {
            get : function() {
                return this._useVertexNormals;
            }
        }
    } );

//    Cesium.PngElevationTileTerrainProvider = PngElevationTileTerrainProvider;

	function createQuantizedMeshTerrainData( hmp, whm, provider, x, y, level, errorpng ){
        var
        	minimumHeight = -16384,
		maximumHeight = 16383,
        	boundingSphere,
		rectangle = provider._tilingScheme.tileXYToRectangle( x, y, level ),
        	horizonOcclusionPoint,
        	encodedNormalBuffer,
        	orientedBoundingBox,
		encodedVertexBuffer,
		westIndices = [],
		southIndices = [],
		eastIndices = [],
		northIndices = [];

// 以下の計算ではなぜかうまくいかず，画面下部に標高が読み込まれないタイルがあらわ荒れる
//		boundingSphere = Cesium.BoundingSphere.fromRectangle3D( 
//				rectangle, provider._tilingScheme.ellipsoid, 0, null );
// 以下ダミーのデータ
//		boundingSphere = new Cesium.BoundingSphere(
//		    		new Cesium.Cartesian3( 1, 2, 3 ), 10000000 );
                boundingSphere = new BoundingSphere(
                                new Cartesian3( 1, 2, 3 ), 10000000 );

        if ( rectangle.width < 
//		Cesium.Math.PI_OVER_TWO + Cesium.Math.EPSILON5 ) {
//	        orientedBoundingBox = Cesium.OrientedBoundingBox.fromRectangle(
                CMath.PI_OVER_TWO + CMath.EPSILON5 ) {
                orientedBoundingBox = OrientedBoundingBox.fromRectangle(
            	rectangle, minimumHeight, maximumHeight, 
            	provider._tilingScheme.ellipsoid
            );
        }

        encodedVertexBuffer = new Uint16Array( hmp.length * 3 );
        for( var j = 0; j < whm; j++ ){
	        for( var i = 0; i < whm; i++ ){
	        	var
	        		k = j * whm + i;
	        
	        	encodedVertexBuffer[ k ] = i / ( whm - 1 ) * 32767;
	        	encodedVertexBuffer[ hmp.length + k ] 
	        			= ( whm - 1 - j ) / ( whm - 1 ) * 32767;
	        	encodedVertexBuffer[ hmp.length * 2 + k ] = hmp[ k ] + 16384;
	        }
        }

		if ( typeof provider._indices == 'undefined' ) {
			// indices関連は
			// タイルによらず，provierインスタンスで1つのデータを使う
	        provider._indices = new Uint16Array( ( whm - 1 ) * ( whm - 1 )  * 6 );
	        for( var j = 0; j < whm - 1; j++ ){
		        for( var i = 0; i < whm - 1; i++ ){
		        	var
		        		k = j * ( whm - 1 )+ i,
		        		k2 = k + j;

		        	provider._indices[ k * 6 ]     = k2;
		        	provider._indices[ k * 6 + 1 ] = k2 + whm + 1;
		        	provider._indices[ k * 6 + 2 ] = k2 + 1;
		        	provider._indices[ k * 6 + 3 ] = k2;
		        	provider._indices[ k * 6 + 4 ] = k2 + whm;
		        	provider._indices[ k * 6 + 5 ] = k2 + whm + 1;
		        }
	        }
	        provider._westIndices = [];
	        provider._southIndices = [];
	        provider._eastIndices = [];
	        provider._northIndices = [];
	        for( var i = 0; i < whm; i++ ){
			    provider._westIndices.push( i * whm );
			    provider._southIndices.push( whm * ( whm - 1 ) + i );
			    provider._eastIndices.push( ( i + 1 ) * whm - 1 );
			    provider._northIndices.push( i );
			}
	    }

    	encodedNormalBuffer = new Uint8Array( whm * whm * 2 );

        for( var j = 0; j < whm; j++ ){
        	var
				lat = rectangle.north * ( 1 - j / whm ) + rectangle.south * j / whm,
	    		sinlat = Math.sin( lat ),
	    		coslat = Math.cos( lat ),
				R = 6378137,	// Webメルカトル地球半径
		 		nz0 = R * 2 * Math.PI / Math.pow( 2, level ) / whm * coslat;

	        for( var i = 0; i < whm; i++ ){
	        	var
	        		k = j * whm + i,
	        		h = hmp[ k ],
	        		nx = ( i == whm - 1 ) ? hmp[ k - 1 ] - h: h - hmp[ k + 1 ],
    	    		ny = ( j == whm - 1 ) ? h - hmp[ k - whm ]: hmp[ k + whm ] - h,
					// 法線ベクトル( nx, ny, nz )の回転行列計算
					// 第1回転　xを回転軸としてPI/2 - lat 回転
					// 第2回転　Z=zを回転軸としてlng回転
					lng = rectangle.west * ( 1 - i / whm ) + rectangle.east * i / whm,
		    		sinlng = Math.sin( lng ),
		    		coslng = Math.cos( lng ),
					rot = [  coslng, sinlat * sinlng, -coslat * sinlng, 
					        -sinlng, sinlat * coslng, -coslat * coslng,
				             0,      coslat,           sinlat ],
	        		nz,
	        		octx,
	        		octy,
	        		rot,
	        		w;		// 作業用変数

				// 法線ベクトル( nx, ny, nz )を回転する
				nz =                 ny * rot[ 7 ] + nz0 * rot[ 8 ];
				w =  nx * rot[ 0 ] + ny * rot[ 1 ] + nz0 * rot[ 2 ];
				ny = nx * rot[ 3 ] + ny * rot[ 4 ] + nz0 * rot[ 5 ];
				nx = w;

				// oct encoding
				w = Math.abs( nx ) + Math.abs( ny ) + Math.abs ( nz );
        		octx = nx / w;
        		octy = ny / w;
        		if ( nz <= 0 ) {
        			w = ( octx >= 0 ? 1 : -1 ) * ( 1 - Math.abs( octy ) );
        			octy = ( octy >= 0 ? 1 : -1 ) * ( 1 - Math.abs( octx ) );
        			octx = w;
/*				// Cigolle et al.2014 Listing 1の別の解釈の場合
	       			var
        				t = 1 - Math.sqrt( octx * octx + octy * octy );
        			octx = ( octx >= 0 ) ? t : -t;
        			octy = ( octy >= 0 ) ? t : -t;
*/
        		}

				// UNORM output
        		encodedNormalBuffer[ k * 2 ] = ( octx + 1 ) * 127.5;
	      		encodedNormalBuffer[ k * 2 + 1 ] = ( octy + 1 ) * 127.5;
    	    }
		};

//        return new Cesium.QuantizedMeshTerrainData( {
        return new QuantizedMeshTerrainData( {
	    minimumHeight : minimumHeight,
            maximumHeight :  maximumHeight,
            quantizedVertices : encodedVertexBuffer ,
            indices : provider._indices,
            boundingSphere : boundingSphere,
//	        orientedBoundingBox : orientedBoundingBox,
			// 無くても動作する
//	        horizonOcclusionPoint : horizonOcclusionPoint,
			// 無くても動作する
 	    encodedNormals : encodedNormalBuffer,
	    westIndices : provider._westIndices,
            southIndices : provider._southIndices,
            eastIndices : provider._eastIndices,
            northIndices : provider._northIndices,
            westSkirtHeight : 1,
            southSkirtHeight : 1,
            eastSkirtHeight : 1,
            northSkirtHeight : 1,
        });
    }

    pngElevationTileTerrainProvider.prototype.requestTileGeometry = function(x, y, level, throttleRequests) {

        var
        	orgx = x,				// リクエストされたx座標を保持
        	orgy = y,				// リクエストされたy座標を保持
        	orgLevel = level,		// リクエストされたズームレベル
        	url = this._url,		// タイル画像URLテンプレート
	        proxy = this._proxy,	// プロキシ
	    	zoomAdj = Math.min( level, this._zoomAdjustment ),
	    						// ズームレベル調整係数．
						    	// zoomAdjustmentよりlevelが小さいときはlevel値そのものになる
	    	xAdj = 1,			// x座標の補正用
	    	yAdj = 0,			// y座標の補正用，webMelcatorは0, LatLngは1
	    	xAdj2, yAdj2,	// 標高マップとタイル画像の倍率の差
	        that = this,
	    	promise;

      	if ( this._tilingScheme.constructor === Cesium.GeographicTilingScheme ) {
	    	yAdj = 1;	
		}
		xAdj2 = Math.pow( 2, zoomAdj + xAdj );
		yAdj2 = Math.pow( 2, zoomAdj + yAdj );
		// ズームレベル調整値によりタイル座係数を変更
		level -= zoomAdj;
		x >>= zoomAdj + xAdj;
		y >>= zoomAdj + yAdj;

        url = url.replace( '{z}', level );
        url = url.replace( '{y}', y );
        url = url.replace( '{x}', x );

//        throttleRequests = defaultValue( throttleRequests, true );
//        if (throttleRequests) {
            //promise = Cesium.throttleRequestByServer (url, Cesium.loadImage );
            //if ( !defined( promise ) ) {
            //    return undefined;
            //}
//        } else {
//            promise = Cesium.loadImage(url);
            promise = loadImage(url);
//        }
//        return Cesium.when( promise, function( image ) {
        return when( promise, function( image ) {
	       	var
            	hmp,							// 出力する標高マップ( HeightMap )
            	wim = image.width,				// 標高タイル画像の横幅
            	whm = that._heightmapWidth,		// 標高マップの横幅
            	errorpng = ( wim === 1 );		// 標高タイル画像の幅が1なら無効タイルとみなし，
            									// errorpng = true

			// 標高マップの準備．標高分解能により各データサイズを変更
			// 誇張のために1以下を指定したときも32bitとして扱ってしうまうが
			// まれなケースであり動作には支障はない
			if ( that._terrainDataStructure.heightScale < 1 ) {
				hmp = new Int32Array( whm * whm )
			} else {
				hmp = new Int16Array( whm * whm )
			}
            if( !errorpng ){
                var
	            	bpp = 4,    							// bytes per pixel
//					pix = Cesium.getImagePixels( image ),	// 標高タイル画像データ
                                        pix = getImagePixels( image ),   // 標高タイル画像データ
					p_hmp = 0,								// 標高マップ内のポインター
					p,										// 標高タイル画像内のポインタ
					px,											// pのx成分
					px0   = ( wim - 1 ) * ( orgx / xAdj2 % 1 ),	// pxの初期値
					py    = ( wim - 1 ) * ( orgy / yAdj2 % 1 ),	// pのy成分
					pxinc = ( wim - 1 ) / ( whm - 1 ) / xAdj2,	// pxの増加量
					pyinc = ( wim - 1 ) / ( whm - 1 ) / yAdj2,	// pyの増加量
					h;										// 標高値

                for( var y = 0; y < whm; ++y ){
                    px = px0;
                    for( var x = 0; x < whm; ++x ){
                        p = ( Math.round( py ) * wim + Math.round( px ) ) * bpp
                        h = 256 * ( 256 * pix[ p+0 ] + pix[ p+1 ] ) + pix[ p+2 ] + 36;
                        h = ( h == 8388608 ) ? 0 : h;	// 無効値補正
                        hmp[ p_hmp++ ] = h << 8 >> 8;	// 24ビットの2補数表現と解釈
                        px += pxinc;
                    }
                    py += pyinc;
                }
            }
            var
            	terrainData;

            if ( that._useVertexNormals ) {
            	terrainData = createQuantizedMeshTerrainData(
            		hmp, whm, that, orgx, orgy, orgLevel, errorpng );
		    } else {
//	            terrainData = new Cesium.HeightmapTerrainData({
                    terrainData = new HeightmapTerrainData({
	                buffer : hmp,
	                width :  whm,
	                height : whm,
	                structure : that._terrainDataStructure,
	                childTileMask : orgLevel < that._maximumLevel && !errorpng ? 15 : 0,
	            } );
		    }
            return terrainData;
/*
       }, function(){			// File Not Foundのときは，ダミーのデータを返す
       	   						// 開発者ツールのエラーメッセージは無くならないが，
       	   						// 若干少なくなる
       	   						// が，深く傾けるとエラーで止まるようになる
            return new Cesium.HeightmapTerrainData({
                buffer : null,
                width :  0,
                height : 0,
                structure : that._terrainDataStructure,
                childTileMask : 0
            } );
*/
        } );
    };

    pngElevationTileTerrainProvider.prototype.getLevelMaximumGeometricError = function(level) {
        return this._levelZeroMaximumGeometricError / (1 << level);
    };

    pngElevationTileTerrainProvider.prototype.getTileDataAvailable = function(x, y, level) {
        return undefined;
    };

export default pngElevationTileTerrainProvider;



